export const BULK_DATA_TYPES = [
  'trainingAndStandardisationSessions',
  'speakingMonitorings',
  'osmMonitoringResults',
  'examinerContactDetails',
  'examinerRoles',
  'osmMonitoringArchiving',
  'examinerCentres',
  'speakingCertifications',
  'writingCertifications',
  'odpAssessments',
  'odpMonitorings',
] as const;

export type BulkDataType = (typeof BULK_DATA_TYPES)[number];

export type BulkUploadLinks = Record<BulkDataType, string>;

export interface BulkActionConfig {
  title: string;
  templateKey: BulkDataType;
}

export const isValidBulkDataType = (value: string | undefined): value is BulkDataType =>
  BULK_DATA_TYPES.includes(value as BulkDataType);
